export default __webpack_public_path__ + "static/media/sign-in.d28d3659.png";